var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13.5926,
    rx: 13,
    ry: 13.321,
    fill: "#61BB46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3264 7.73135L7.67881 7.90459C7.45347 7.90459 7.28448 8.13558 7.28448 8.30882C7.22814 11.2539 7.67881 13.8524 10.2701 16.5088C12.8614 19.1651 15.2837 19.4538 18.1567 19.4538C18.382 19.4538 18.551 19.2806 18.551 19.0496L18.72 16.3355C18.72 16.1045 18.551 15.9313 18.382 15.8736L15.7344 15.4693C15.6217 15.4693 15.4527 15.4693 15.3964 15.5848C14.7767 16.22 14.3261 16.682 14.1571 16.7975C13.8754 16.682 12.8614 16.22 11.7348 15.0074C10.6081 13.8524 10.0448 12.6975 9.87578 12.4088C10.1011 12.1778 10.6081 11.6581 11.0588 11.1961C11.1714 11.0806 11.1714 10.9651 11.1714 10.8496L10.7771 8.07783C10.7771 7.90459 10.5518 7.73135 10.3264 7.73135Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.129e083bfc5688507c7aecf0ac83a5b9.svg";
export { ForwardRef as ReactComponent };